module.exports = __webpack_public_path__ + "bfcddb38f32efadb2b9f32e2ad523c9d.pdf";